function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9898 9.13885C16.3938 8.7623 16.4161 8.12953 16.0395 7.72551C15.663 7.3215 15.0302 7.29924 14.6262 7.67579L11.7001 10.403L8.97284 7.47689C8.59628 7.07287 7.96351 7.05061 7.5595 7.42716C7.15548 7.80371 7.13322 8.43649 7.50977 8.8405L10.237 11.7666L7.31087 14.4939C6.90686 14.8704 6.8846 15.5032 7.26115 15.9072C7.6377 16.3112 8.27047 16.3335 8.67449 15.9569L11.6006 13.2297L14.3278 16.1558C14.7044 16.5598 15.3372 16.5821 15.7412 16.2055C16.1452 15.829 16.1675 15.1962 15.7909 14.7922L13.0637 11.8661L15.9898 9.13885Z",
  fill: "#252733"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.650391 11.8164C0.650391 5.74127 5.57526 0.816406 11.6504 0.816406C17.7255 0.816406 22.6504 5.74127 22.6504 11.8164C22.6504 17.8915 17.7255 22.8164 11.6504 22.8164C5.57526 22.8164 0.650391 17.8915 0.650391 11.8164ZM11.6504 20.8164C6.67983 20.8164 2.65039 16.787 2.65039 11.8164C2.65039 6.84584 6.67983 2.81641 11.6504 2.81641C16.621 2.81641 20.6504 6.84584 20.6504 11.8164C20.6504 16.787 16.621 20.8164 11.6504 20.8164Z",
  fill: "#252733"
});

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.676f59c4.svg";
export { ForwardRef as ReactComponent };